module.exports = __webpack_public_path__ + "static/media/user4-michael morgan.b9cedf06.jpg";